import {
  normalizeVideoProvider,
  VIDEO_PROVIDER_ENG_GUAVIDEO,
  VIDEO_PROVIDER_OMINI_SEEDANCE,
} from './projectRuntime';

export const isDreaminaProxySeedance20Provider = (provider) => [
  VIDEO_PROVIDER_ENG_GUAVIDEO,
  VIDEO_PROVIDER_OMINI_SEEDANCE,
].includes(normalizeVideoProvider(provider));

const sourceCandidates = (item) => typeof item === 'string' ? [item] : [
  item?.originalUrl,
  item?.originalImageUrl,
  item?.originalVideoUrl,
  item?.originalAudioUrl,
  item?.sourceUrl,
  item?.sourceImageUrl,
  item?.sourceVideoUrl,
  item?.sourceAudioUrl,
  item?.rawUrl,
  item?.url,
  item?.imageUrl,
  item?.videoUrl,
  item?.audioUrl,
  item?.image_url?.url,
  item?.video_url?.url,
  item?.audio_url?.url,
];

export const getDreaminaProxyOriginalUrl = (item) => sourceCandidates(item)
  .find((value) => typeof value === 'string' && /^(https:\/\/|data:image\/)/i.test(value.trim()))
  ?.trim() || '';

export const requireDreaminaProxyOriginalUrl = (item) => {
  const url = getDreaminaProxyOriginalUrl(item);
  if (!url) throw new Error('海外 Seedance 2.0 参考素材缺少公网 HTTPS 原始 URL，请重新选择素材；旧素材库 ID 不能用于 Dreamina v3 代理');
  return url;
};
